import { Controller } from "@hotwired/stimulus"

// 設問の判定条件を画面遷移なしで部分更新する。
// select の change で fetch PATCH を送り、成功時に select / 矢印の class を切り替える。
const SET_CLASSES = [
  "border-red-300",
  "bg-red-50",
  "text-red-700",
  "font-medium",
  "focus:border-red-500",
  "focus:ring-red-500"
]
const UNSET_CLASSES = [
  "border-gray-300",
  "bg-white",
  "text-gray-500",
  "focus:border-indigo-500",
  "focus:ring-indigo-500"
]

export default class extends Controller {
  static targets = ["select", "icon"]
  static values = { url: String }

  async submit() {
    const select = this.selectTarget
    const formData = new FormData()
    formData.append("judgment_condition_id", select.value)

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": csrfToken, "Accept": "application/json" },
      body: formData
    })

    if (response.ok) {
      this.applyAppearance(select.value !== "")
    }
  }

  applyAppearance(isSet) {
    const select = this.selectTarget
    const icon = this.hasIconTarget ? this.iconTarget : null

    const remove = isSet ? UNSET_CLASSES : SET_CLASSES
    const add = isSet ? SET_CLASSES : UNSET_CLASSES

    remove.forEach((c) => select.classList.remove(c))
    add.forEach((c) => select.classList.add(c))

    if (icon) {
      if (isSet) {
        icon.classList.remove("text-gray-500")
        icon.classList.add("text-red-700")
      } else {
        icon.classList.remove("text-red-700")
        icon.classList.add("text-gray-500")
      }
    }
  }
}
